module.exports = __webpack_public_path__ + "assets/img/prd3-2.a174818d.jpg";